function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#E6E7E8;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#0095D5;}\r\n\t.st3{fill:#4CAF45;}\r\n\t.st4{fill:#434244;}\r\n\t.st5{font-family:'HelveticaNeue-Light';}\r\n\t.st6{font-size:0.9287px;}\r\n\t.st7{fill:#F8991D;}\r\n\t.st8{fill:#C4122F;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 55.11,
  y: 29.04,
  className: "st3",
  width: 8.09,
  height: 10.41
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 64.29,
  y: 63.55,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref5 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 42.9541 26.2349)",
  className: "st4 st5 st6"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 1.22,
  y: 42.33,
  className: "st0",
  width: 5.66,
  height: 5.18
});

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 63.55,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 9.13,
  y: 63.55,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 36.72,
  y: 63.55,
  className: "st3",
  width: 8.09,
  height: 10.41
}));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 45.92,
  y: 63.55,
  className: "st3",
  width: 8.09,
  height: 10.41
}));

var _ref11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  y: 52.05,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 36.72,
  y: 52.05,
  className: "st3",
  width: 8.09,
  height: 10.41
}));

var _ref13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 45.9,
  y: 52.05,
  className: "st3",
  width: 8.09,
  height: 10.41
}));

var _ref14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 27.48,
  y: 29.06,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  y: 40.55,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 18.31,
  y: 40.55,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 27.48,
  y: 40.55,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 18.31,
  y: 63.55,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 45.92,
  y: 40.55,
  className: "st3",
  width: 8.09,
  height: 10.41
}));

var _ref20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 17.56,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 18.31,
  y: 17.56,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 27.48,
  y: 17.56,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 6.03,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 9.13,
  y: 52.03,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 9.13,
  y: 17.52,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 9.13,
  y: 6.03,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 18.31,
  y: 29.06,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 36.72,
  y: 29.06,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 36.72,
  y: 17.56,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 82.64,
  y: 29.04,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 45.92,
  y: 29.04,
  className: "st3",
  width: 8.09,
  height: 10.41
}));

var _ref32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 55.1,
  y: 52.05,
  className: "st3",
  width: 8.09,
  height: 10.41
}));

var _ref33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 55.12,
  y: 40.55,
  className: "st3",
  width: 8.09,
  height: 10.41
})));

var _ref34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 82.64,
  y: 52.05,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 91.91,
  y: 6.05,
  className: "st0",
  width: 8.09,
  height: 10.41
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  x: 82.66,
  y: 29.11,
  className: "st0",
  width: 8.09,
  height: 10.41
});

var _ref37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 91.91,
  y: 63.55,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 91.91,
  y: 52.05,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 73.46,
  y: 29.04,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 73.46,
  y: 40.55,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 82.64,
  y: 17.56,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 91.91,
  y: 29.04,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 73.46,
  y: 63.56,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 91.91,
  y: 6.03,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 91.91,
  y: 17.56,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 82.64,
  y: 63.56,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 73.46,
  y: 52.05,
  className: "st0",
  width: 8.09,
  height: 10.41
})));

var _ref48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 91.91,
  y: 40.55,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 82.64,
  y: 40.55,
  className: "st0",
  width: 8.09,
  height: 10.41
})));

var _ref50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  y: 29.04,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref51 = /*#__PURE__*/React.createElement("rect", {
  x: 64.3,
  y: 29.02,
  className: "st1",
  width: 8.09,
  height: 10.41
});

var _ref52 = /*#__PURE__*/React.createElement("rect", {
  x: 64.29,
  y: 40.56,
  className: "st0",
  width: 8.09,
  height: 10.41
});

var _ref53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_3_",
  x: 65.34,
  y: 42.27,
  width: 6.01,
  height: 4.21
}));

var _ref54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 64.29,
  y: 52.05,
  className: "st0",
  width: 8.09,
  height: 10.41
}));

var _ref55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 73.46,
  y: 17.56,
  className: "st0",
  width: 8.09,
  height: 10.41
})));

var _ref56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 55.11,
  y: 63.55,
  className: "st0",
  width: 8.09,
  height: 10.41
})));

var _ref57 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 27.48,
  y: 52.05,
  className: "st0",
  width: 8.09,
  height: 10.41
})));

var _ref58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 73.46,
  y: 6.03,
  className: "st0",
  width: 8.09,
  height: 10.41
})));

var _ref59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 82.64,
  y: 6.03,
  className: "st0",
  width: 8.09,
  height: 10.41
})));

var _ref60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 55.11,
  y: 17.56,
  className: "st3",
  width: 8.09,
  height: 10.41
}));

var _ref61 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 45.92,
  y: 17.56,
  className: "st3",
  width: 8.09,
  height: 10.41
}));

var _ref62 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 64.29,
  y: 29.04,
  className: "st3",
  width: 8.09,
  height: 10.41
})));

var _ref63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 9.13,
  y: 29.06,
  className: "st0",
  width: 8.09,
  height: 10.41
})));

var _ref64 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 9.13,
  y: 40.55,
  className: "st0",
  width: 8.09,
  height: 10.41
})));

var _ref65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 18.31,
  y: 52.05,
  className: "st0",
  width: 8.09,
  height: 10.41
})));

var _ref66 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 27.48,
  y: 63.55,
  className: "st0",
  width: 8.09,
  height: 10.41
})));

var _ref67 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 36.72,
  y: 40.55,
  className: "st0",
  width: 8.09,
  height: 10.41
})));

var _ref68 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 64.29,
  y: 17.56,
  className: "st3",
  width: 8.09,
  height: 10.41
})));

var SvgIconLearningDevelopment = function SvgIconLearningDevelopment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 80",
    style: {
      enableBackground: "new 0 0 100 80"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, /*#__PURE__*/React.createElement("g", null, _ref52, /*#__PURE__*/React.createElement("g", null, _ref53, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible",
      fill: "#E6E7E8"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })))), _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLearningDevelopment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-learning-development.ad177e23.svg";
export { ForwardRef as ReactComponent };